// Manejar data-toggles del menu 2026
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { sectionAnimation } from "./animation/sectionAnimation";

gsap.registerPlugin(ScrollTrigger);

// Hover en Desktop y click en mobile, detectar si es isTouchDevice
const isTouchDevice = () => window.matchMedia('(hover: none)').matches;
const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

document.querySelectorAll('[data-toggle-megamenu]').forEach(trigger => {
    let hoverTimer = null

    if (isMobile() || isTouchDevice()) {
        // mobile con click
        trigger.addEventListener('click', (e) => {
            e.preventDefault()
            openMegamenu(trigger)
        })
    } else {
        // mouseneter con delay en desktop
        trigger.addEventListener('mouseenter', () => {
            hoverTimer = setTimeout(() => openMegamenu(trigger), 200)
        })

        trigger.addEventListener('mouseleave', () => {
            clearTimeout(hoverTimer)
        })

        // En desktop el item con megamenú no navega: la interacción es el hover.
        // Si además clican, evitamos el link y abrimos el panel.
        trigger.addEventListener('click', (e) => {
            e.preventDefault()
            openMegamenu(trigger)
        })
    }
})

function openMegamenu(trigger) {
    const tab = trigger.dataset.toggleMegamenu
    const megamenu = document.querySelector('#megamenu')
    const megamenuWrapper = megamenu.querySelector('.megamenu__wrapper')
   

    // Si el tab ya está activo, no hacer nada
    if (megamenu.dataset.activeTab === tab) return



    // gsap.set(megamenuWrapperUl, {
    //     height: megamenuWrapper.offsetHeight,
    //     // opacity: 0.5,
    // })

    // Quitar active de todos y añadir solo al actual
    document.querySelectorAll('[data-toggle-megamenu]').forEach(t => t.classList.remove('active'))
    trigger.classList.add('active')

    // Ocultar todos los panels
    megamenu.querySelectorAll('[data-tab-content]').forEach(panel => {
        panel.classList.remove('is-visible')
    })

    // Mostrar el panel activo
    const activePanel = megamenu.querySelector(`[data-tab-content="${tab}"]`)
    if (activePanel) {
        activePanel.classList.add('is-visible')

        gsap.to(megamenuWrapper, {
            duration: .450,
            opacity: 1,
            ease: "power1.in",
        })
    }

    // Abrir megamenu y guardar tab activo
    megamenu.classList.add('is-open')
    megamenu.dataset.activeTab = tab
}

// Cerrar con botón
document.querySelector('#megamenu [data-close-megamenu]').addEventListener('click', () => {
    const megamenu = document.querySelector('#megamenu')
    megamenu.classList.remove('is-open')
    megamenu.dataset.activeTab = ''
    document.querySelectorAll('[data-toggle-megamenu]').forEach(t => t.classList.remove('active'))
})

// Cerrar megamenu al hacer scroll
function closeMegamenu() {
    const megamenu = document.querySelector('#megamenu')
    if (!megamenu.classList.contains('is-open')) return

    megamenu.classList.remove('is-open')
    megamenu.dataset.activeTab = ''
    document.querySelectorAll('[data-toggle-megamenu]').forEach(t => t.classList.remove('active'))
     megamenu.querySelectorAll('.megamenu__wrapper_ul').forEach(ul => ul.classList.remove('is-visible'))
}

let scrollDelta = 0

// Lanzar función de cerrar megamenu si listener de wheel mayor a 200px
window.addEventListener('wheel', (e) => {
    if (isMobile()) return

    const megamenu = document.querySelector('#megamenu')
    if (!megamenu.classList.contains('is-open')) {
        scrollDelta = 0
        return
    }

    scrollDelta += Math.abs(e.deltaY)

    const threshold = 100

    if (scrollDelta > threshold) {
        closeMegamenu()
        scrollDelta = 0
    }
}, { passive: true })


// Click en menu de mobile

document.querySelector('.nav-mobile .nav-mobile__opener').addEventListener('click', function() {
    const megamenu = document.querySelector('#megamenu')

    megamenu.classList.toggle('is-open');
    this.textContent = megamenu.classList.contains('is-open') ? "close" : "menu";
})

// Click back en mobile

const backMegamenu = document.querySelector('[data-back-megamenu]');

backMegamenu.addEventListener('click', () => {
  const megamenu = document.querySelector('#megamenu')
    const megamenuWrapperUl = megamenu.querySelector('.megamenu__wrapper_ul')
    megamenuWrapperUl.classList.remove('is-visible')
   megamenu.removeAttribute('data-active-tab');
});


// Ocultar back logo 100vh antes de llegar al top y según altura del footer

const scLogoScrollUp = document.querySelector(".sc-logo-scroll-up .sc-logo-container");
const footer = document.querySelector(".footer");

// Header scroll: scrolled-top / header-visible + logo scroll-up

const headerBar = document.querySelector('#masthead .site-header_header');

const PX_THRESHOLD = 36;

let lastScrollTop = window.scrollY;
let headerTicking = false;

// Límites para el logo scroll-up (funciones: se recalculan en cada uso)
const logoTopLimit = () => window.innerHeight;
const logoBottomLimit = () =>
    document.body.scrollHeight - window.innerHeight - (footer?.offsetHeight || 0);

// Control del logo scroll-up
let logoVisible = false;
let logoHideTimer = null; 
const LOGO_VISIBLE_MS = 800;

function setLogoVisible(show) {
    if (!scLogoScrollUp) return;

    clearTimeout(logoHideTimer);

    if (show) {
        logoVisible = true;
        gsap.to(scLogoScrollUp, { opacity: 1, duration: 0.3, overwrite: 'auto' });

        logoHideTimer = setTimeout(() => {
            logoVisible = false;
            gsap.to(scLogoScrollUp, { opacity: 0, duration: 0.3, overwrite: 'auto' });
        }, LOGO_VISIBLE_MS);

    } else {
        if (!logoVisible) return;
        logoVisible = false;
        gsap.to(scLogoScrollUp, { opacity: 0, duration: 0.3, overwrite: 'auto' });
    }
}

// Estado inicial en primera carga
if (window.scrollY === 0) {
    headerBar.classList.add('scrolled-top');
}

function updateHeader() {
    headerTicking = false;

    const currentScroll = window.scrollY;
    const scrollThreshold = lastScrollTop + PX_THRESHOLD;

    // ---- En el top (2px de margen) ----
    if (currentScroll <= 2) {
        setLogoVisible(false);
        lastScrollTop = currentScroll;

    // ---- Scroll down ----
    } else if (currentScroll > lastScrollTop) {
        setLogoVisible(false);

        if (currentScroll > scrollThreshold) {
            headerBar.classList.remove('scrolled-top', 'header-visible');

            // Al bajar desde arriba de todo, esperar a que el header
            // se esconda antes de quitar el logo gafas
            if (lastScrollTop <= PX_THRESHOLD) {
                setTimeout(() => {
                    headerBar.classList.remove('show-logo-glasses');
                }, 300);
            }

            lastScrollTop = currentScroll;
        }
        // Si no supera el threshold no actualizamos lastScrollTop
        // (tolerancia acumulativa de 36px, como el original)

    // ---- Scroll up ----
    } else if (currentScroll < lastScrollTop) {
        headerBar.classList.add('header-visible');

        setLogoVisible(
            currentScroll > logoTopLimit() && currentScroll < logoBottomLimit()
        );

        lastScrollTop = currentScroll;
    }
}

window.addEventListener('scroll', () => {
    if (!headerTicking) {
        headerTicking = true;
        requestAnimationFrame(updateHeader);
    }
}, { passive: true });


// Opener menu right

const menuRightOpener = document.querySelectorAll(".menu-right__opener");
const menuRight = document.querySelector(".site-header .menu-right");


menuRightOpener.forEach(opener => {
    opener.addEventListener("click", () => {
        const megamenu = document.querySelector('#megamenu')
        menuRight.classList.toggle("menu-right-open");
        opener.classList.toggle("menu-right-open");
        megamenu.classList.remove("is-open");
    });
});


// Layout del header: padding + animaciones de mastheadBottom / introText

const masthead = document.querySelector("#masthead.site-header");
const mastheadBottom = masthead.querySelector(".masthead__bottom");
const bodyPage = document.querySelector("#page.site");
const scLogoMenu = document.querySelector(".sc-logo-menu");
const introText = document.querySelector("#masthead .intro-text");

let headerTweens = [];

function killHeaderTweens() {
    headerTweens.forEach(t => {
        t.scrollTrigger?.kill();
        t.kill();
    });
    headerTweens = [];
    // Devolver los elementos a su estado natural antes de re-medir
    gsap.set([mastheadBottom, introText], { clearProps: "all" });
}

function updateLayout() {
    if (!masthead || !bodyPage) return;

    killHeaderTweens();

    const mobile = isMobile();

    // ---- Padding compensatorio (solo desktop) ----
    if (mobile) {
        bodyPage.style.paddingTop = '';
    } else {
        // Medimos DESPUÉS del clearProps: altura natural real
        const mastheadHeight = masthead.offsetHeight;

        bodyPage.style.paddingTop = `${mastheadHeight}px`;

        headerTweens.push(
            gsap.fromTo(bodyPage,
                { paddingTop: mastheadHeight },
                {
                    paddingTop: 0,
                    immediateRender: false,
                    scrollTrigger: {
                        trigger: bodyPage,
                        start: "top top",
                        end: "+=100",
                        scrub: 1,
                        invalidateOnRefresh: true,
                    },
                    // onComplete: () => {
                    //     sectionAnimation();
                    // }
                }
            )
        );
    }

    // ---- Intro text ----
    headerTweens.push(
        gsap.to(introText, {
            opacity: 0,
            yPercent: -200,
            scrollTrigger: {
                trigger: bodyPage,
                start: "top top",
                end: "+=20",
                scrub: 1,
                invalidateOnRefresh: true,
            }
        })
    );

    // ---- Logo Menu ----
    headerTweens.push(
        gsap.to(scLogoMenu, {
            y: -400,
            scrollTrigger: {
                trigger: bodyPage,
                start: "top top",
                end: "+=50",
                scrub: 1,
                invalidateOnRefresh: true,
            }
        })
    );

    // ---- mastheadBottom: desplazamiento ----
    headerTweens.push(
        gsap.to(mastheadBottom, {
            // Valor en función: se recalcula en cada refresh gracias a invalidateOnRefresh
            y: () => -masthead.offsetHeight,
            scrollTrigger: {
                trigger: bodyPage,
                start: "top top",
                end: "+=100",
                scrub: mobile ? 1 : 1.3, 
                invalidateOnRefresh: true,
            }
        })
    );

    // ---- mastheadBottom: colapso de altura (solo desktop; bug de .matches arreglado) ----
    if (!mobile) {
        headerTweens.push(
            gsap.to(mastheadBottom, {
                height: 0,
                scrollTrigger: {
                    trigger: bodyPage,
                    start: "top top",
                    end: "+=30",
                    toggleActions: "play none none reverse",
                }
            })
        );
    }

    ScrollTrigger.refresh();
}

updateLayout();

/* Pestaña abierta en segundo plano: el navegador no ejecuta requestAnimationFrame ni el
   ticker de GSAP hasta que se entra en ella, y la medida del header y los ScrollTrigger
   se quedan con valores de una pagina que aun no se veia (el header salia encima del
   contenido al entrar). Al hacerse visible se vuelve a medir y a colocar todo. pageshow
   cubre la vuelta desde la cache de navegacion atras/adelante. */
function relayoutWhenVisible() {
    if (document.visibilityState !== 'visible') return;
    requestAnimationFrame(updateLayout);
}
document.addEventListener('visibilitychange', relayoutWhenVisible);
window.addEventListener('pageshow', (e) => { if (e.persisted) relayoutWhenVisible(); });

// Resize con debounce + ignorar resizes de solo-altura (barra del navegador móvil)
let resizeTimer = null;
let lastWidth = window.innerWidth;

window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        updateLayout();
    }, 200);
});